import { DakokuService } from "@/service/DakokuService";
import { HakenDakokuData, HakenModifyDatas, GetHakenKinmuListRes } from "@/types/Dakoku";
import { computed, ref, Ref } from "vue";
import { DialogService } from "@/service/DialogService";
import { timeToHHmm } from "@/filters/common";

/*
 * 勤務一覧
 */
export function useHakenKinmuList() {
  let loading = ref(0);
  let isError = ref(false);

  const sumKinmuTime = ref('');
  const sumAfterModify = ref('');
  const hakenListData: Ref<GetHakenKinmuListRes | null> = ref(null)

  // 指定期間の勤務一覧を取得する
  const getHakenKinmuListByPeriod = async (
    year: number,
    month: number,
    syuugyouBasyoId: number,
    koyouKeiyakuId: number | null,
    targetUserId: number,
    dakokuId: number | null = null
  ) => {
    loading.value++
    const srv = new DakokuService()
    hakenListData.value = await srv.getHakenKinmuList(year, month, syuugyouBasyoId, koyouKeiyakuId, targetUserId, dakokuId)
    if (!hakenListData.value) {
      loading.value--
      return
    }

    await convertHakenKinmuList()
    loading.value--
  }

  const getHakenKinmuListBySummaryId = async (summaryId: number) => {
    const srv = new DakokuService()
    hakenListData.value = await srv.getHakenKinmuListBySummaryId(summaryId)
    if (!hakenListData.value) {
      return
    }
    loading.value++

    await convertHakenKinmuList()
    loading.value--
  }

  const convertHakenKinmuList = async () => {
    if (!hakenListData.value) {
      return
    }

    // 派遣先打刻に総務が編集した内容
    let hakenModInfos = hakenListData.value.hakenModifies;

    let tmpHour = 0;
    let tmpMinute = 0;

    let tmpModifyHour = 0;
    let tmpModifyMinute = 0;

    hakenListData.value.list.forEach(function (value) {

      let dateKey = value.key;

      // 勤務時間を設定
      if (value.kinmus.length !== 0) {
        let syoteiWorkTimes = "";

        value.kinmus.forEach(function (val) {
          syoteiWorkTimes = (val.syotei_work_times !== undefined && val.syotei_work_times !== null)
            ? val.syotei_work_times
            : '';


          if (val.modifiedKinmuTimes === undefined || val.modifiedKinmuTimes === "") {
            val.modifiedKinmuTimes = syoteiWorkTimes;

            if (val.modifiedKinmuTimes !== "") {
              let tmpModifyTime = val.modifiedKinmuTimes.split(":");
              tmpModifyHour += parseInt(tmpModifyTime[0], 10);
              tmpModifyMinute += parseInt(tmpModifyTime[1], 10);
            }
          }

          if (syoteiWorkTimes != "") {
            let tmpTime = syoteiWorkTimes.split(":");
            tmpHour += parseInt(tmpTime[0], 10);
            tmpMinute += parseInt(tmpTime[1], 10);
          }

          // 派遣先打刻に総務が編集した内容を設定
          let hakenInfoItem = hakenModInfos.filter((v: any) => v.key === dateKey);
          if (hakenInfoItem.length !== 0) {

            val.soumu_note1 = hakenInfoItem[0].soumu_note1 == null ? "" : hakenInfoItem[0].soumu_note1;
            val.soumu_note2 = hakenInfoItem[0].soumu_note2 == null ? "" : hakenInfoItem[0].soumu_note2;
          }

          // フォーマット
          val.kyuukei_times = timeToHHmm(val.kyuukei_times);
          val.syotei_work_times = timeToHHmm(val.syotei_work_times);
          val.houteinai_zangyou_times = timeToHHmm(val.houteinai_zangyou_times);
          val.jikangai_work_times = timeToHHmm(val.jikangai_work_times);
          val.shinya_warimashi_times = timeToHHmm(val.shinya_warimashi_times);
          val.chikoku_times = timeToHHmm(val.chikoku_times);
          val.soutai_times = timeToHHmm(val.soutai_times);
          val.yuukyuu_times = timeToHHmm(val.yuukyuu_times);
        });

      }

      // 勤務データがない場合、空データを設定
      if (value.kinmus.length === 0) {
        let data = <HakenDakokuData>({});

        // 派遣先打刻に総務が編集した内容を設定
        let hakenInfoItem = hakenModInfos.filter((v: any) => v.key === dateKey);
        if (hakenInfoItem.length !== 0) {

          data.soumu_note1 = hakenInfoItem[0].soumu_note1 == null ? "" : hakenInfoItem[0].soumu_note1;
          data.soumu_note2 = hakenInfoItem[0].soumu_note2 == null ? "" : hakenInfoItem[0].soumu_note2;
        }
        // data.soumu_note1 = "";
        // data.soumu_note2 = "";
        data.modifiedKinmuTimes = "";

        value.kinmus.push(data);
        // value.kinmus[0].currentModify = hakenInfoItem;
      }
    });

    tmpHour += Math.trunc(tmpMinute / 60);
    tmpMinute = tmpMinute % 60; // 剰余
    sumKinmuTime.value = tmpHour + ':' + ('0' + tmpMinute).slice(-2);

    tmpModifyHour += Math.trunc(tmpModifyMinute / 60);
    // tmpModifyHour += tmpModifyMinute / 60;
    tmpModifyMinute = tmpModifyMinute % 60; // 剰余
    sumAfterModify.value = tmpModifyHour + ':' + ('0' + tmpModifyMinute).slice(-2);
  }

  const isCreating = ref(false);

  // 派遣者用編集情報を登録します。
  const setHakenModifies = async (params: HakenModifyDatas) => {
    isCreating.value = true

    const srv = new DakokuService()
    DialogService.nowloading('登録中...')

    const res = await srv.setHakenModifies(params)
    if (res) {
      await DialogService.info({
        text: `編集情報を登録しました`
      }, true)
      isCreating.value = false
      return true
    } else {
      await DialogService.error({
        text: '予期せぬ事態が発生し登録に失敗しました'
      }, true)
      isCreating.value = false
      return false
    }
  }


  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isLoading,
    sumKinmuTime,
    sumAfterModify,
    hakenListData,
    getHakenKinmuListByPeriod,
    getHakenKinmuListBySummaryId,
    setHakenModifies
  }
}
